module.exports = __webpack_public_path__ + "img/screenshot_2.f1c1f681.jpg";